import React, { createContext, useContext, useState } from 'react';
import { ToastContextType, ToastData, ToastProviderProps } from './interface';
import { Toast } from '@src/components/Toast/Toast';
import { createPortal } from 'react-dom';

const ToastContext = createContext<ToastContextType>({ toast: null, setToast: undefined });

const ToastProvider = ({ children }: ToastProviderProps) => {
  const [toast, setToast] = useState<ToastData | null>(null);
  return (
    <ToastContext.Provider value={{ toast, setToast }}>
      <>
        {toast &&
          createPortal(<Toast severity={toast.severity} message={toast.message} />, document.body)}
        {children}
      </>
    </ToastContext.Provider>
  );
};

const useToastContext = () => useContext(ToastContext);

const useToast = () => {
  const { setToast } = useToastContext();
  const success = (message: string) => setToast?.({ message, severity: 'success' });
  const error = (message: string) => setToast?.({ message, severity: 'error' });
  const info = (message: string) => setToast?.({ message, severity: 'info' });
  return { info, success, error };
};

export { ToastContext, ToastProvider, useToast, useToastContext };
